import React from "react";
import * as app_consts from "../../../../constants/react_app_consts";
import CreatePhysicalGoodsReceivedWizardIndex from "./wizard_pages/warehouse/CreatePhysicalGoodsReceivedWizardIndex";
import CompleteKYCRegWizardIndex from "./wizard_pages/onboarding/CompleteKYCRegWizardIndex";
import AssignCustomerAccountIndex from "./wizard_pages/onboarding/AssignCustomerAccountIndex";
import OnboardCompanyWizardIndex from "./wizard_pages/onboarding/OnboardCompanyWizardIndex";
import CreatePhsyicalDeliveryNoteIndex from "./wizard_pages/onboarding/CreatePhsyicalDeliveryNoteIndex";
import CreateLoadingOrderIndex from "./wizard_pages/onboarding/CreateLoadingOrderIndex";

const WizardComp = ({
  type,
  selectedWeighbridgeTicket,
  weighbridgeContext,
  onWeighbridgeSelectionLockChange,
}) => {
  return (
    <>
      {type === app_consts.CREATE_PHYSICAL_GOODS_RECEIVED_TICKET ? (
        <CreatePhysicalGoodsReceivedWizardIndex
          wizardType={type}
          selectedWeighbridgeTicket={selectedWeighbridgeTicket}
          weighbridgeContext={weighbridgeContext}
          onWeighbridgeSelectionLockChange={onWeighbridgeSelectionLockChange}
        />
      ) : type === app_consts.COMPLETE_KYC_REGISTRATION ? (
        <CompleteKYCRegWizardIndex wizardType={type} />
      ) : type === app_consts.ASSIGN_CUSTOMER_ACCOUNT ? (
        <AssignCustomerAccountIndex wizardType={type} />
      ) : type === app_consts.ONBOARD_COMPANY ? (
        <OnboardCompanyWizardIndex wizardType={type} />
      ) : type === app_consts.CREATE_PHYSICAL_DELIVERY_NOTE_TICKET ? (
        <CreatePhsyicalDeliveryNoteIndex wizardType={type} selectedWeighbridgeTicket={selectedWeighbridgeTicket} />
      ) : type === app_consts.CREATE_LOADING_ORDER ? (
        <CreateLoadingOrderIndex wizardType={type} />
      ) : (
        ""
      )}
    </>
  );
};

export default WizardComp;
